import React from 'react';

import Chip, { ChipProps } from 'components/ui/Chip/Chip';
import Icon from 'components/Icon/Icon';
import { Color } from 'types/colors';
import { SpriteIcon } from 'types/icons';

import css from './IconChip.module.scss';

interface Props extends ChipProps {
    iconName?: SpriteIcon;
    iconColor?: Color;
    emoji?: string;
}

const IconChip: React.FC<Props> = ({ iconName, iconColor = 'gray3', emoji, children, ...rest }) => {
    const beforeContent = iconName ? (
        <Icon name={iconName} width={16} className={css.icon} color={iconColor} />
    ) : (
        <div className={css.emoji}>{emoji}</div>
    );

    return (
        <Chip isCompact className={css.inputChip} beforeContent={beforeContent} {...rest}>
            {children}
        </Chip>
    );
};

export default React.memo(IconChip);
